/**
 * webserviceCallStandardPost_RejectObject_Class.js
 * 
 * Return an instance of this class when 
 * webserviceCallStandardPost(...) calls reject() on the promise
 * 
 */

//////////////////////////////////
// JavaScript directive:   all variables have to be declared with "var", maybe other things
"use strict";


/**
 * 
 */
export class WebserviceCallStandardPost_RejectObject_Class {
	
	/**
	 * 
	 */
	constructor() {

    }

}

